import React from 'react';
import CartItem from './CartItem';
import { useRecoilValue } from 'recoil';
import { addToProjectAtom } from '../../../state';
import { IProduct } from '../../../types';

const CartTable = () => {
  const selectedProducts = useRecoilValue<IProduct[] | any>(addToProjectAtom);

  return (
    <div className="w-full">
      <div className="hidden md:block">
        <table className="min-w-full bg-white">
          <thead>
            <tr className='hover:!bg-transparent'>
              <th className="text-left py-2 px-4 border-b">Item</th>
              <th className="text-left py-2 px-4 border-b">Quantity</th>
            </tr>
          </thead>
          <tbody>
            {selectedProducts.map((product: IProduct, index: any) => (
              <CartItem key={index} product={product} index={index} />
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile View */}
      <div className="md:hidden">
        {selectedProducts.map((product: IProduct, index: any) => (
          <div key={index} className="border-b py-4">
            <CartItem product={product} index={index} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CartTable; 